import { render, staticRenderFns } from "./sector_path.vue?vue&type=template&id=2bfdb0dc&scoped=true&"
import script from "./sector_path.vue?vue&type=script&lang=js&"
export * from "./sector_path.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdb0dc",
  null
  
)

export default component.exports